import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { PasslyButton } from '@app/components';

const HELP_LINK = 'https://helpdesk.kaseya.com/hc/en-gb';

const WantHelp: React.SFC = () => {
    const { translation } = useTypedTranslation();
    const openHelp = () => {
        window.open(HELP_LINK, '_blank');
    };

    return (
        <div className='information__content'>
            <h3 className='header--h3'>{translation('GS_WANT_HELP')}</h3>
            <p>{translation('GS_WANT_HELP_TEXT')}</p>
            <PasslyButton
                variant='contained'
                color='primary'
                onClick={openHelp}
                target='_blank'
            >
                {translation('GS_HELP_BUTTON')}
            </PasslyButton>
        </div>

    );
};

export default WantHelp;
